import React, { ReactNode, ComponentProps } from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import SectionMessage from '@atlaskit/section-message';

export const FormErrorWrapper = styled.div`
  margin-bottom: ${gridSize() * 2}px;
`;
const SectionErrorWrapper = styled.div`
  margin-top: ${gridSize()}px;
  margin-bottom: ${gridSize()}px;
`;

export default function FormError({
  testId,
  title,
  children,
  appearance = 'warning',
}: {
  testId?: string;
  title?: string;
  appearance?: ComponentProps<typeof SectionMessage>['appearance'];
  children: ReactNode;
}) {
  return children ? (
    <FormErrorWrapper role="alert">
      <SectionMessage testId={testId || 'form-error'} appearance={appearance} title={title}>
        {children}
      </SectionMessage>
    </FormErrorWrapper>
  ) : null;
}

export function SectionError({
  id,
  testId,
  title,
  children,
}: {
  id?: string;
  testId?: string;
  title?: string;
  children: ReactNode;
}) {
  return children ? (
    <SectionErrorWrapper id={id}>
      <SectionMessage testId={testId || 'form-error'} appearance="warning" title={title}>
        {children}
      </SectionMessage>
    </SectionErrorWrapper>
  ) : null;
}
